const getSecondsPerBeat = (bpm: number, signature: { numerator: number, denominator: number }) => {
  return (60 / bpm) * (4 / signature.denominator);
}

const getSecondsPerBar = (bpm: number, signature: { numerator: number, denominator: number }) => {
  return getSecondsPerBeat(bpm, signature) * signature.numerator;
}

const getPlayheadDataFromTime = (playheadTime: number, bpm: number, signature: { numerator: number, denominator: number }) => {
  const secondsPerBeat = getSecondsPerBeat(bpm, signature);
  const secondsPerBar = getSecondsPerBar(bpm, signature);
  const bar = Math.floor(playheadTime / secondsPerBar) + 1;
  const beat = Math.floor(playheadTime / secondsPerBeat) % signature.numerator + 1;
  return { playheadTime, bar, beat }
}

const getPlayheadDataFromPosition = (bar: number, beat: number, bpm: number, signature: { numerator: number, denominator: number }) => {
  const secondsPerBeat = getSecondsPerBeat(bpm, signature);
  const secondsPerBar = getSecondsPerBar(bpm, signature);
  const playheadTime = (bar - 1) * secondsPerBar + (beat - 1) * secondsPerBeat;
  return { playheadTime, bar, beat }
}

export { getSecondsPerBeat, getSecondsPerBar, getPlayheadDataFromTime, getPlayheadDataFromPosition }
